import React from 'react';
import { Helmet } from 'react-helmet-async';
import { DEFAULT_SEO_DESCRIPTION, DEFAULT_SEO_TITLE } from '../data/languages';

export function SEO({
  title = DEFAULT_SEO_TITLE,
  description = DEFAULT_SEO_DESCRIPTION,
  canonical = 'https://bhol.app/',
  ogImage = 'https://bhol.app/og-image.jpg',
  ogType = 'website',
  article = null,
  noIndex = false
}) {
  const fullTitle = title === DEFAULT_SEO_TITLE
    ? title
    : `${title} | Bhol`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={noIndex ? 'noindex, nofollow' : 'index, follow'} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Bhol" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonical} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:site" content="@bholbholbhol" />
      <meta name="twitter:creator" content="@bholbholbhol" />

      {article && (
        <>
          <meta property="article:published_time" content={article.publishedTime} />
          {article.modifiedTime && (
            <meta property="article:modified_time" content={article.modifiedTime} />
          )}
          {article.tags && article.tags.map(tag => (
            <meta key={tag} property="article:tag" content={tag} />
          ))}
        </>
      )}
    </Helmet>
  );
}

export default SEO;
